import React from 'react';
import './ToolWindow.css';

export default ({ title, icon, actionBar, onClose, children }) => (
  <div className={title ? 'ToolWindow' : 'ToolWindow closed'}>
    <div className="header">
      <div className={icon} />
      <div className="title">{title}</div>
      <div className="actions">
        {actionBar}
        <button
          className="fontawesome-remove close"
          onClick={onClose}
        />
      </div>
    </div>
    <div className="content">
      {children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/ToolWindow/ToolWindow.jsx